<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SMS_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <div class="comm_label">
              {{ smsData.messageCmid }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEND_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ smsData.messageSendStatusName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ smsData.requestDTM }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="this.$t('MSG_TXT_SEND_USR_TEL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ smsData.sendPhone }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="this.$t('MSG_TXT_RECP_USR_TEL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ smsData.destPhone }}
            </div>
          </div>
          <!-- <div class="col-xs-1 nodata" />
          <div class="col-xs-3" /> -->
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ smsData.subject }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CNTN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-textarea
              v-model="smsData.messageBody"
              :readonly="true"
              rows="8"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        v-permission:read="pageId"
        type="button"
        class="comm_btn_border"
        @click="onCloseClick"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00016_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    messageCmid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      smsData: {},
    };
  },
  datasets: [],
  computed: {},
  watch: {},
  mounted() {
    if (!utils.isEmpty(this.messageCmid)) {
      this.smsDataLoad();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    smsDataLoad() {
      http.request(this.pageId, 'DTS_CMS_00050', {
        path: {
          'message-cmid': this.messageCmid,
        },
      }).then(res => {
        this.smsData = res.data;
        this.smsData.requestDTM = res.data.requestDTM.substr(0, utils.indexOf(res.data.requestDTM, '.'));
      });
    },
    onCloseClick() {
      this.$emit('onDetailAndCancelClick');
    },
  },
};
</script>
<style scoped>
</style>
